import React, { useState } from 'react';
import closeicon from "../../../Assets/AppComponent/Group 427320024.svg"
import styles  from "../../../StyleSheet/MainComponent/Management/EmployeeEdit.module.scss"
import { useDispatch } from 'react-redux';
import {resetEmployeeEditActionsdata} from  "../../../Redux/Slice"

export const Employee_edit = ({ employee,setshow , show ,passingpayloads ,reliver_calls  }) => {
     const dispatch = useDispatch()
  const [formadata, setformdata] = useState({
    first_name:employee?.user_id?.first_name || '',
    phone_number:employee?.user_id?.phone_number || ''
  });
  const [error , seterror] = useState({})


  const handleSubmit = (e) => {
    e.preventDefault();
  };

const onClose =()=>{
    setshow(false)
}

const validateForm = (formadata) => {
  const errors = {};

  if (!formadata.first_name.trim()) {
    errors.first_name = 'Name is required';
  }

  if (!formadata.phone_number.trim()) {
    errors.phone_number = 'Phone number is required';
  } else if (!/^\d{10}$/.test(formadata.phone_number)) {
    errors.phone_number = 'Phone number must be 10 digits';
  }

  return errors;
};



const onSave = () => {
  const errors = validateForm(formadata);
  seterror(errors);

  if (Object.keys(errors).length === 0) {
    const payload ={
        data :formadata,
        payload_pass:passingpayloads,
        EditId:employee?.id,
        Funcations: () => {
                setshow(false)
        },
        reliver_calls:reliver_calls,
       }
    dispatch(resetEmployeeEditActionsdata(payload));

    }
    
};

 const capitalizeFirstLetter = (value) => {
  if (typeof value !== "string") return value;
  return value.charAt(0).toUpperCase() + value.slice(1);
};
const  Handlechanges =(e)=>{
    const {name , value} = e.target
if(name =="first_name"){
 setformdata({
        ...formadata,
        [name]: capitalizeFirstLetter(value),
      });
    }
    else{
         setformdata({
        ...formadata,
        [name]: value,
      });
    }
       seterror({
        ...error,
        [name]: "",
      });

}

  return (
 <>
     <div className={styles.overlay}>
      <div className={styles.modal}>
      <div className={styles.Edit_headers}>
          <h3>Edit Employee</h3>

        <button className="close-btn" onClick={() => onClose()}>
          <img src={closeicon} alt="Close" />
        </button>
      </div>
        <div onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.formGroup}>
            <label>Name</label>
            <input
              type="text"
              value={formadata?.first_name}
              onChange={Handlechanges}
              name="first_name"
            />
              {error.first_name && <small style={{ color: 'red',paddingTop:"3px" }}>{error.first_name}</small>}

          </div>
          <div className={styles.formGroup}>
            <label>Phone Number</label>
            <input
              type="number"
              value={formadata.phone_number}
            onChange={(e) => {
                        const value = e.target.value;

                        const phoneRegex = /^[1-9][0-9]{0,9}$/;
                        if (
                          value.length <= 10 &&
                          (phoneRegex.test(value) || value === "")
                        ) {
                          Handlechanges(e);
                        }
                      }}
              name="phone_number"
            />
              {error.phone_number && <small style={{ color: 'red',paddingTop:"3px" }}>{error.phone_number}</small>}

          </div>
          <div className={styles.actions}>
            <button type="submit" onClick={onSave} className={styles.save}>Save</button>
          </div>
        </div>
      </div>
    </div>

 </>
  );
};
